module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-6 height-100 no-padding width-100",
    style: ('height:' + _vm.windowHeight + 'px!important;background:url(' + _vm.bg + ');background-size:cover;'),
    attrs: {
      "id": "home-bg-video"
    }
  }, [(_vm.videoId) ? _c('div', {
    staticClass: "bgvideo",
    staticStyle: {
      "margin-left": "-80px"
    }
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoId,
      "player-vars": {
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        disablekb: 1,
        loop: 1,
        playlist: _vm.videoId,
        fadeOnStartTime: 500
      },
      "player-width": _vm.windowWidth + 160,
      "player-height": _vm.windowHeight + 90,
      "mute": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "display-table height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 text-center"
  }, [_c('h2', {
    staticClass: "vw-bold display-block font-family-alt font-weight-700 letter-spacing-2 text-uppercase text-white xs-title-extra-large sm-title-extra-large-3 title-extra-large-5"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('p', {
    staticClass: "vw-bold font-family-alt letter-spacing-1 margin-3 no-margin-bottom no-margin-rl text-gray-light xs-text-large text-extra-large text-uppercase"
  }, [_vm._t("subtitle")], 2)]), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-base-color sm-btn-medium btn-large margin-4-5 no-margin-bottom no-margin-rl",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.buttonText) + "\n                            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a33e7aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/intro.vue
// module id = 234
// module chunks = 1